var React = require('react');

function CartDrawerIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M3.33431 5.83333L17.2176 5.83333L14.7437 14.1667L3.33431 14.1667L3.33431 5.83333Z","stroke":"#4D5B68","strokeWidth":"1.66667","key":0}),React.createElement("path",{"d":"M0.833984 2.5H2.35359C2.89505 2.5 3.33398 2.93894 3.33398 3.48039V5.83333","stroke":"#4D5B68","strokeWidth":"1.66667","strokeLinecap":"round","key":1}),React.createElement("circle",{"cx":"13.3337","cy":"17.4997","r":"1.66667","fill":"#4D5B68","key":2}),React.createElement("circle",{"cx":"4.16667","cy":"17.4997","r":"1.66667","fill":"#4D5B68","key":3})]);
}

CartDrawerIcon.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = CartDrawerIcon;

CartDrawerIcon.default = CartDrawerIcon;
